<template>
  <v-form ref="form" v-model="valid" class="settings elevation-2">
    <UCardHeader :header="header" />
    <v-flex align-self-end>
      <v-btn
        class="settings__header-btn"
        color="secondary"
        outline
        small
        @click="dialogAddUser = true"
      >
        New
      </v-btn>
    </v-flex>
    <UDialog
      :show="dialogAddUser"
      :actions="dialogAddUserActions"
      title="New User"
      data-tid="modalSaveUserPermission"
      @closeDialog="
        dialogAddUser = false;
        newUserEmail = '';
        newUserRole = '';
      "
      @saveUserPermissions="callSaveUserPermission"
    >
      <div slot="body">
        <v-text-field
          :rules="emailRules"
          v-model="newUserEmail"
          label="E-Mail"
          class="autofocus"
          color="secondary"
        />
        <v-select
          :items="[
            { value: 'editor', text: 'Editor' },
            { value: 'admin', text: 'Admin' }
          ]"
          :rules="[value => !!value || 'Please select a role.']"
          v-model="newUserRole"
          solo
          label="Role"
        />
      </div>
    </UDialog>

    <v-list>
      <SettingsUsersCardRow
        v-for="user in users"
        :key="user.id"
        v-bind="{ user, currentUser }"
        data-tid="user-row"
        @save="saveUserPermission"
        @delete="openDeleteUserDialog"
        @resendInvitation="resendInvitation"
      />
    </v-list>

    <UDialog
      :show="dialogDeleteUser"
      :actions="dialogDeleteUserActions"
      title="Delete User"
      @closeDialog="dialogDeleteUser = false"
      @deleteUser="callDeleteUser"
    >
      <div slot="body">
        Are you sure you want to delete the user
        <strong>{{ deleteUserName }}</strong
        >? This action cannot be undone.
      </div>
    </UDialog>
  </v-form>
</template>

<script>
import UCardHeader from "@/components/UCardHeader";
import UDialog from "@/components/UDialog";
import SettingsUsersCardRow from "@/components/SettingsUsersCardRow";

export default {
  components: {
    UCardHeader,
    UDialog,
    SettingsUsersCardRow
  },
  props: {
    currentUser: {
      type: Object,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    saveUserPermission: {
      type: Function,
      required: true
    },
    removeUserPermission: {
      type: Function,
      required: true
    },
    resendInvitation: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      header: "Users",
      deleteUserDialog: false,
      userForDeletion: false,
      deleteUserName: false,
      deleteUserMail: false,
      valid: true,
      newUserEmail: "",
      newUserRole: "",
      dialogAddUser: false,
      dialogDeleteUser: false,
      emailRules: [
        value => !!value || "Please enter an email address.",
        value =>
          /^\S+@\S+$/.test(value) || "The email address need to be valid."
      ]
    };
  },
  computed: {
    dialogAddUserActions() {
      return [
        {
          id: "create-user-button-confirm",
          label: "Add",
          button_color: "primary",
          action_name: "saveUserPermissions",
          action_value1: this.newUserEmail,
          action_value2: this.newUserRole
        }
      ];
    },
    dialogDeleteUserActions() {
      return [
        {
          id: "delete-button",
          label: "Delete",
          button_color: "primary",
          action_name: "deleteUser",
          action_value1: this.userForDeletion
        }
      ];
    }
  },
  methods: {
    openDeleteUserDialog(user) {
      this.userForDeletion = user;
      this.deleteUserMail = user.email;
      this.deleteUserName = user.google_user_id
        ? `${user.firstname} ${user.lastname}`
        : user.email;
      this.dialogDeleteUser = true;
    },
    formValid() {
      return this.$refs.form.validate();
    },
    callSaveUserPermission() {
      if (
        this.$refs.form.validate() &&
        this.saveUserPermission({
          email: this.newUserEmail,
          role: this.newUserRole
        })
      ) {
        this.newUserEmail = "";
        this.newUserRole = "";
        this.dialogAddUser = false;
        this.$refs.form.resetValidation();
      }
    },
    callDeleteUser(user) {
      this.removeUserPermission(user);
      this.dialogDeleteUser = false;
    }
  }
};
</script>

<style lang="scss">
.settings {
  @include card();
}
.settings__header-btn {
  margin: 0;
}
</style>
